import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Navbar           from './components/layout/Navbar';
import LoginPage        from './pages/LoginPage';
import DashboardPage    from './pages/DashboardPage';
import CoursePage       from './pages/CoursePage';
import AuthCallbackPage from './pages/AuthCallbackPage';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center' }}>
      <div style={{ textAlign:'center' }}>
        <div style={{ width:36, height:36, background:'var(--gold)', borderRadius:10, display:'inline-flex', alignItems:'center', justifyContent:'center', fontFamily:"'Fraunces',serif", fontWeight:700, fontSize:20, color:'#0c0d0f', marginBottom:12 }}>M</div>
        <div style={{ fontSize:'0.85rem', color:'#4a4842' }}>Loading…</div>
      </div>
    </div>
  );
  return user ? children : <Navigate to="/login" replace/>;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/auth"     element={<AuthCallbackPage/>}/>
          <Route path="/login"    element={<LoginPage/>}/>
          <Route path="/dashboard" element={<PrivateRoute><><Navbar/><DashboardPage/></></PrivateRoute>}/>
          <Route path="/course/:courseId" element={<PrivateRoute><><Navbar/><CoursePage/></></PrivateRoute>}/>
          <Route path="*" element={<Navigate to="/dashboard" replace/>}/>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
